import store from '@/store'
import axios from 'axios'
import Cart from '@/connection/cart'
import User from '@/connection/user'
export default {

  async getCompaniesByLocation (lat, lng) {
    console.log(lat, lng)
    try {
      let result = await axios.get(store.getters.getLocations + '/locations/companies/' + store.state.company.companyId + '?lat=' + lat + '&lon=' + lng)
      if (result.data) {
        return result.data
      } else {
        console.log(' error response', result)
        return {error: true, code: 400, msg:'Erro ao obter lojas.'}
      }
    } catch(e) {
      let error = {e} 
      console.log(error)
      return {error: true, code: 500, msg:'Erro ao obter lojas.'}
    }
  },

  async getDeliveryFee (addressId) {
    try {
      // TODO global interceptor to post closed endpoints
      let sessionToken = await User.getSessionToken('session_token')
      if (sessionToken) {
        let products = Cart.getCartItensToDelivery()
        let total = Cart.getTotalToDelivery()
        let data = {
          cart_product_list: products,
          delivery_address_id: addressId,
          payment_type: 1,
          total_price: total
        }
        if (store.state.choicedCompanyId) {
          data.sub_company_id = store.state.choicedCompanyId
        }
        let header = { 'Authorization': sessionToken}
        let response = await axios.post(store.getters.getDeliveryApi + '/delivery-fee',
        data, { headers: header } )
        if (response.data) {
          return response.data
        } else {
          console.log(' error response', response)
          return {error: true, code: 400, msg: 'Sessão Expirada.'}
        }
      } else {
        return {error: true, code: 400, msg: 'Sessão Expirada.'}
      }
    } catch(e) {
      let error = {e}
      console.log('error', error.e)
      return {error: true, code: 500, msg:'Erro ao obter endereço.,'}
    }
  },

  async getAdressByZipCode (cep) {
    try {
      let response = await axios.get(store.getters.getLocations + '/locations/cep-api?zip_code=' + cep)
      return response.data
    } catch(e) {
      let error = {e}
      console.log(error)
      return {error: true, msg:'Erro ao obter endereço'}
    }
    
    
  },

  async getAdressByGoogle (address) {
    let response = await axios.get(store.getters.getLocations + '/locations/google-api?params=' + address) 
    if (response.data.results && response.data.results.length && response.data.results[0].geometry.location.lat){
      return response.data.results[0].geometry.location
    } else {
      return null
    }
  },

  async getAddressByLocation (locationString) {
    try {
      let response = await axios.get(store.getters.getLocations + '/locations/google-api-location?params=' + locationString) 
      if (response.data) {
        return response.data
      } else {
        return null
      }
    } catch (e) {
      return null
    }
  },

  containsPoint (point, path) {
    var crossings = 0
    // for each edge
    for (var i = 0; i < path.length; i++) {
      let a = path[i]
      let j = i + 1
      if (j >= path.length) {
        j = 0
      }
      var b = path[j]
      if (this.rayCrossesSegment(point, a, b)) {
        crossings++;
      }
    }
    // odd number of crossings?
    return (crossings % 2 == 1)
  },

  rayCrossesSegment(point, a, b) {
    let px = point[1],
      py = point[0],
      ax = a[0],
      ay = a[1],
      bx = b[0],
      by = b[1]
    if (ay > by) {
      ax = b[0]
      ay = b[1]
      bx = a[0]
      by = a[1]
    }
    // alter longitude to cater for 180 degree crossings
    if (px < 0) {
      px += 360
    }
    if (ax < 0) {
      ax += 360
    }
    if (bx < 0) {
      bx += 360
    }
    if (py == ay || py == by) {
      py += 0.00000001
    }
    if ((py > by || py < ay) || (px > Math.max(ax, bx))) {
      return false
    }
    if (px < Math.min(ax, bx)) {
      return true
    }
    let red = (ax != bx) ? ((by - ay) / (bx - ax)) : Infinity
    let blue = (ax != px) ? ((py - ay) / (px - ax)) : Infinity
    return (blue >= red)
  }
}